<template>
    <div class="signup container">
        <form @submit.prevent="signUp" class="card-panel">
            <h2 class="deep-purple-text center-align">SignUp</h2>
            <div class="field">
                <label for="email">Your email:</label>
                <input type="email" name="email" v-model="email">
            </div>
            <div class="field">
                <label for="password">Your password:</label>
                <input type="password" name="password" v-model="password">
            </div>
            <div class="field">
                <label for="email">Your username</label>
                <input type="text" name="alias" v-model="alias">
            </div>
            <p v-if="feedback" class="red-text center-align">{{ feedback }}</p>
            <div class="field center-align">
                <button class="btn deep-purple">SignUp</button>
            </div>
        </form>
    </div>
</template>

<script>
import slugify from 'slugify'
import db from "@/firebase/init"
import firebase from 'firebase'
export default {
    name: 'SignUp',
    data() {
        return {
            email: null,
            password: null,
            alias: null,
            feedback: null,
            slug: null
        }
    },
    methods: {
        signUp() {
            if(this.alias && this.email && this.password) {
                this.slug = slugify(this.alias, {
                    remove: /[#_*+~.()'"!:@]/g,
                    lower: true,
                    replacement: '-'
                })
                let ref = db.collection('users').doc(this.slug)
                ref.get()
                .then(doc => {
                    if(doc.exists) {
                        this.feedback = "This username has already been taken. Please try another username."
                    } else {
                        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                        .then(cred => {
                            ref.set({
                                alias: this.alias,
                                geolocation: null,
                                user_id: cred.user.uid
                            })
                        })
                        .then(() => {
                            this.$router.push({ name: 'GMap' })
                        })
                        .catch(error => {
                            console.log(error)
                            this.feedback = error.message
                        })
                    }
                })
            } else {
                this.feedback = "You must enter all the fields."
            }
        }
    }
}
</script>

<style>
    .signup .field {
        margin-bottom: 1%;
    }

    .signup h2 {
        font-size: 2.4em;
    }

    .signup {
        max-width: 50vw;
        margin-top: 2%;
    }

    .signup input:focus {
        border-color: #673AB7 !important;
    }

    @media screen and (max-width: 768px) {
        .signup {
            max-width: 100vw;
        }

        .signup .card-panel {
            box-shadow: none;
            padding: 0px !important;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/auth/SignUp.vue